import isEmail from '../../src/helpers/is-email';
import { VSRCI_OTP_CHANNELS } from '../constants/srci-gtm-events';

/**
 * Get otp channel from maskedValidationChannel. This data is used for GTM
 * @param {String} maskedValidationChannel getting as part of generateOTP request
 * @returns {String} Email, SMS etc
 */
const getOtpDeliveryChannel = maskedValidationChannel => {
  let otpChannel = VSRCI_OTP_CHANNELS.EMAIL; //default channel supported by VISA
  const maskedChannels = maskedValidationChannel && maskedValidationChannel.split(',');

  if (Array.isArray(maskedChannels) && maskedChannels.length > 1) {
    //This is the max at a time VISA SRC can support
    return VSRCI_OTP_CHANNELS.EMAIL_SMS;
  }
  //channel either masked email or phone number
  if (Array.isArray(maskedChannels) && maskedChannels.length == 1) {
    const maskedChannel = maskedChannels[0].trim();
    if (maskedChannel !== '' && isEmail(maskedChannel)) {
      otpChannel = VSRCI_OTP_CHANNELS.EMAIL;
    } else {
      otpChannel = VSRCI_OTP_CHANNELS.SMS;
    }
  }
  return otpChannel;
};

export default getOtpDeliveryChannel;
